function getMaterialLabel(configurationName, translate) {
  const translated = translate(configurationName)
  return translated || configurationName
}

function getViewerTitle(viewerTitle) {
  return /^VLF\s+Wheel\s+TCF-?37$/i.test(viewerTitle || '')
    ? '巨久轮毂 TCF-37'
    : viewerTitle
}

module.exports = {
  getMaterialLabel,
  getViewerTitle
}
